import React from 'react'
export default function Admin() {
  return (
    <div>
      <h1>Admin page</h1>
    </div>
  )
}
